import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { tokenManager } from '../../contexts/AuthContext'; 

// 1. 引入你的組件
import StaffShiftRequestCalendar from '../components/StaffShiftRequestCalendar';
// 假設你之後會整一個「查看正式更表」的組件，暫時我們先用一個 Placeholder 或者你有現成的可以換上去
// import StaffRosterView from '../components/StaffRosterView'; 
import StaffRosterView from '../components/StaffRosterView';


const StaffDashboard = () => {
  const navigate = useNavigate();

  useEffect(() => {
        // 設定這一頁專屬的 Browser Tab 標題
        document.title = "更表管理 | Kaka卡卡兒童超跑"; 

        // (Optional) Cleanup: 當離開呢頁時，改返做預設標題
        return () => {
            document.title = "Kaka卡卡兒童超跑";
        };
    }, []);

  // 2. 新增 State 控制顯示邊個畫面 ('request' = 報更, 'roster' = 睇正式更表)
  const [currentView, setCurrentView] = useState('request');

  useEffect(() => {
    const token = tokenManager.getToken();
    if (!token) {
      navigate('/ssms/login');
    }
  }, [navigate]);

  const handleLogout = () => {
    tokenManager.removeToken();
    navigate('/ssms/login');
  };

  // 獲取用戶名
  const username = tokenManager.getUserData().user?.username || '員工';

  return (
    <div className="min-h-screen bg-blue-50">
      {/* --- Top Navigation Bar --- */}
      <nav className="bg-white shadow mb-4 sticky top-0 z-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between h-16 items-center">
            
            {/* === 左邊 & 中間：標題 + 切換按鈕 === */}
            <div className="flex items-center gap-6">
              {/* 標題 Logo */}
              <div className="flex items-center gap-2">
                <h1 className="text-xl font-bold text-gray-800 hidden sm:block">
                  SSMS
                </h1>
                <span className="px-2 py-1 bg-blue-100 text-blue-800 text-xs rounded-full">
                  更表管理系統
                </span>
              </div>

              {/* 🌟 新設計：功能切換 Dropdown */}
              <div className="relative group">
                {/* 1. Select 本體 */}
                <select
                  value={currentView}
                  onChange={(e) => setCurrentView(e.target.value)}
                  className={`
                    appearance-none 
                    cursor-pointer
                    pl-4 pr-10 py-2 
                    rounded-lg 
                    border 
                    text-sm font-bold 
                    shadow-sm 
                    focus:outline-none focus:ring-2 focus:ring-offset-1 transition-all
                    ${currentView === 'request' 
                      ? 'bg-white border-blue-300 text-blue-700 focus:ring-blue-500' // 報更模式：藍色系
                      : 'bg-white border-indigo-300 text-indigo-700 focus:ring-indigo-500' // 更表模式：紫色系
                    }
                  `}
                >
                  <option value="request">📝 我要報更 (Shift Request)</option>
                  <option value="roster">📅 查看更表 (Roster View)</option>
                </select>

                {/* 2. 右邊的箭頭 Icon (裝飾用) */}
                <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-3">
                  <svg 
                    className={`h-4 w-4 ${currentView === 'request' ? 'text-blue-500' : 'text-indigo-500'}`} 
                    fill="none" 
                    viewBox="0 0 24 24" 
                    stroke="currentColor"
                  >
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
                  </svg>
                </div>
              </div>
            </div>
            
            {/* === 右邊：登出按鈕 (上) + 用戶名 (下) === */}
            <div className="flex flex-col items-end justify-center leading-tight">
              <button 
                onClick={handleLogout}
                className="text-red-600 hover:text-red-800 text-sm font-bold hover:underline"
              >
                登出
              </button>
              <span className="text-[10px] text-gray-400 mt-0.5">
                Hi, {username}
              </span>
            </div>

          </div>
        </div>
      </nav>

{/*<main className="w-full px-4 px-4 sm:px-6 lg:px-8 pb-10 flex flex-col">*/}
<main className="w-full px-4 pb-4 h-[calc(100vh-64px)] flex flex-col">
        
        {/* 統一的外框容器 (跟 Manager 一樣) */}
        <div 
            className="bg-white rounded-xl shadow-lg overflow-hidden flex flex-col" 
            style={{ height: '85vh' }}
        >
            {/* 上半部：說明文字 (Header) */}
            <div className="flex-shrink-0 px-4 pt-4 pb-2">
                {currentView === 'request' ? (
                    <div className="text-xs text-gray-600 border-l-4 border-blue-500 pl-3">
                        <strong>說明：</strong> 請拖拉您想上班的時間段，完成後按「提交變更」。
                    </div>
                ) : (
                    <div className="text-xs text-gray-600 border-l-4 border-indigo-500 pl-3">
                        <strong>說明：</strong> 這是店長已確認的正式更表 (唯讀)。
                    </div>
                )}
            </div>

            {/* 下半部：日曆內容 (自動填滿) */}
            <div className="flex-1 relative min-h-0 px-4 pb-4">
                {currentView === 'request' ? (
                    // 報更日曆
                    <StaffShiftRequestCalendar />
                ) : ( 
                    <StaffRosterView />
                )}
            </div>

        </div>
      </main>
    </div>
  );
};

export default StaffDashboard;